module.exports = __webpack_public_path__ + "img/order.121df529.svg";